import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Bundle the JSON synchronously so `t()` returns translated strings on the
// very first render — no fetch round-trip, no key-flash. Vite inlines these
// into the main chunk; ~75 KB per locale gzips fine for a single-tenant SPA.
import en from "../public/locales/en/translation.json";
import ar from "../public/locales/ar/translation.json";

i18n.use(LanguageDetector).use(initReactI18next).init({
  fallbackLng: "en",
  supportedLngs: ["en", "ar"],
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
